exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._177Sw4fOUOErgU_AEHw5EB {\n  border-radius: 0.4rem;\n  box-shadow: 0 0 2px #000;\n  font-size: 1.1rem;\n  height: 13rem;\n  overflow: hidden;\n  padding: 1rem;\n  position: relative;\n  -webkit-user-select: none;\n  width: 13rem;\n  word-wrap: break-word;\n}\n.VIuoG4gIPayDwX5gzVPrc {\n  cursor: pointer;\n}\n.VIuoG4gIPayDwX5gzVPrc:hover {\n  box-shadow: 0 0 2px 1px #555;\n}\n._2BfWvz_qLkeKIh8CT_BN8R {\n  background: #fff;\n}\n._7oTJVp5SphHwngXfn4Sz2 {\n  background: #000;\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"card-box": "_177Sw4fOUOErgU_AEHw5EB",
	"clickable": "VIuoG4gIPayDwX5gzVPrc",
	"white-card": "_2BfWvz_qLkeKIh8CT_BN8R",
	"black-card": "_7oTJVp5SphHwngXfn4Sz2"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/card-box.styl
 ** module id = 249
 ** module chunks = 0
 **/